import BaseModel from '../core/BaseModel';
import UserModel from '@/models/UserModel';

export default class RatingModel extends BaseModel {
    constructor() {
        super({
                name: "rate",
                tableName: 'rate',
            },
            {
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    unique: true,
                    default: 'gen_random_uuid()',
                    display: false
                },
                number_rate: {
                    name: 'number_rate',
                    type: "Integer",
                    label: 'Number Rate',
                    nullable: true
                },
                obj_id: {
                    name: 'obj_id',
                    type: "Uuid",
                    label: 'Object ID',
                    nullable: true
                },
                note: {
                    name: 'note',
                    type: "Text",
                    label: 'Note',
                    nullable: true
                },
                created_at: {
                    name: 'created_at',
                    type: "Timestamp",
                    label: 'Created At',
                    default: 'now()'
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Timestamp",
                    label: 'Updated At',
                    default: 'now()'
                },
                updated_by: {
                    name: 'updated_by',
                    type: "Uuid",
                    label: 'Updated By',
                    nullable: true,
                    models: new UserModel()
                },
                created_by: {
                    name: 'created_by',
                    type: "Uuid",
                    label: 'Created By',
                    nullable: true,
                    models: new UserModel()
                },
                active: {
                    name: 'active',
                    type: "Boolean",
                    label: 'Active',
                    default: true
                },
                deleted: {
                    name: 'deleted',
                    type: "Boolean",
                    label: 'Deleted',
                    default: false
                },
                uid: {
                    name: 'uid',
                    type: "Uuid",
                    label: 'UID',
                    nullable: true
                }
            })
    }
}